import { useQuery } from 'react-query';

import PESService from 'App/services/PESService';

function useFetchPatientMedications(patientId) {
    return useQuery(
        ['patient', patientId, 'medications'],
        () => (!patientId ? null : PESService.getPatientMedications(patientId)),
        {
            retry: false,
            refetchInterval: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchPatientMedications;
